import { render, staticRenderFns } from "./DnDisciplineStatements.vue?vue&type=template&id=0992878a&scoped=true&"
import script from "./DnDisciplineStatements.vue?vue&type=script&lang=js&"
export * from "./DnDisciplineStatements.vue?vue&type=script&lang=js&"
import style0 from "./DnDisciplineStatements.vue?vue&type=style&index=0&id=0992878a&lang=scss&scoped=true&"
import style1 from "./DnDisciplineStatements.vue?vue&type=style&index=1&id=0992878a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0992878a",
  null
  
)

export default component.exports